export default "__VITE_ASSET__BXeJcX5a__"